













import { Vue, Component } from 'vue-property-decorator'
import { apiPaymentRebateConfig, apiPaymentGetTbAuthLink } from '@/api/setting'
@Component({
    components: {}
})
export default class StorageIndex extends Vue {
    /** S Data **/
    info: any = {}
    /** E Data **/

    /** S Methods **/
    init() {
        apiPaymentRebateConfig().then(res => {
            console.log(res);
            this.info = res
        }).catch(err => {
            console.log(err);
        })
    }
    authorization() {
        console.log('淘宝授权');
        apiPaymentGetTbAuthLink().then(res => {
            console.log(res.auth_link);
            window.open(res.auth_link, '_blank')
        })
    }
    result() {
        this.$router.push({
            path: '/setting/cps/result',
            query: {
                code: 'FtQYZp8Gi4JT359uviRUEpao5716562'
            }
        })
    }
    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.init()
    }
    /** E Life Cycle **/
}
